module.exports = __webpack_public_path__ + "img/medMission_041022_I.dbb9b705.jpg";